import Spacing from '../Spacing';
import AppointmentSectionStyle3 from '../Section/AppointmentSection/AppointmentSectionStyle3';
import Section from '../Section';

export default function Profile() {

    return (
        <>
            <div style={{ backgroundColor: '#0e6ebe', height: '100%', width: '100%' }}>
                <Spacing md="100" />
            </div>
            <Section>
                <AppointmentSectionStyle3 title="Profile & Subscriptions" />
            </Section>
        </>
    );
}